function removeFeedbackValidity(element) {
  element.innerText = '';
  if (element.classList.value.includes('taurus-valid')) {
    element.classList.remove('taurus-valid');
  }
  if (element.classList.value.includes('taurus-invalid')) {
    element.classList.remove('taurus-invalid');
  }
  // if (element.classList.value.includes('d-block')) {
  //   element.classList.remove('d-block');
  // }
}

function addFeedbackValidity(vObj, feedbackDiv, valid, feedbackOpts) {
  if (valid && feedbackOpts.valid) {
    feedbackDiv.classList.add('taurus-valid');
    feedbackDiv.innerText = feedbackDiv.attributes.validfeedback
      ? feedbackDiv.attributes.validfeedback.value
      : 'Looks Good!';
  } else if (!valid && feedbackOpts.invalid) {
    const invalidRules = vObj.errorBag.filter((r) => r.valid === false);
    feedbackDiv.innerText = feedbackDiv.attributes.invalidfeedback
      ? feedbackDiv.attributes.invalidfeedback.value
      : invalidRules[0].feedback; // get first rule
    feedbackDiv.classList.add('taurus-invalid');
  }
  // feedbackDiv.classList.add('d-block');
}

function removeControlValidity(element) {
  if (element.classList.value.includes('is-valid')) {
    element.classList.remove('is-valid');
  }
  if (element.classList.value.includes('is-invalid')) {
    element.classList.remove('is-invalid');
  }
}

function addControlValidity(element, valid, controlOpts) {
  if (valid && controlOpts.valid) {
    element.classList.add('is-valid');
  } else if (!valid && controlOpts.invalid) {
    element.classList.add('is-invalid');
  }
}

function feedbackValidity(vObj, valid, feedbackOpts) {
  const feedbackDiv = document.getElementsByName(vObj.compId)[0];
  if (!feedbackDiv) {
    console.error(
      `You've forgotton to add a feedback element with name='${vObj.compId}'`,
    );
    return;
  }
  removeFeedbackValidity(feedbackDiv);
  addFeedbackValidity(vObj, feedbackDiv, valid, feedbackOpts);
}

function controlValidity(vObj, valid, controlOpts) {
  const controlElement = document.getElementById(vObj.compId);
  removeControlValidity(controlElement);
  addControlValidity(controlElement, valid, controlOpts);
}

export const setValidity = (vObj, options) => {
  const valid = !vObj.errorBag.some((r) => r.valid === false);
  if (options) {
    if (options.feedback) {
      // run the feeback div validity
      feedbackValidity(vObj, valid, options.feedback);
    }
    if (options.control) {
      // run control validity
      controlValidity(vObj, valid, options.control);
    }
  }
};
